import { Checkbox, CheckboxProps } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

type Props = {
  checked: boolean;
  indeterminate?: boolean;
  onToggle: () => void;
} & Omit<CheckboxProps, 'checked' | 'indeterminate' | 'onChange'>;

const FieldCheckbox: React.FC<Props> = ({ checked, indeterminate, onToggle, ...props }) => {
  return <Checkbox size="xs" checked={checked} indeterminate={indeterminate} onChange={onToggle} {...props} />;
};

export default observer(FieldCheckbox);
